import { Controller, useFormContext } from 'react-hook-form';
import { PhoneInput } from '@ds';
import { ComponentProps } from 'react';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

type ControlledPhoneInputProps = Omit<
  ComponentProps<typeof PhoneInput>,
  'inputAriaLabel' | 'selectAriaLabel' | 'onChange' | 'value'
> & {
  name: string;
  disabled?: boolean;
  enableMultipleCountries?: boolean;
};

export const ControlledPhoneInput = ({
  name,
  disabled,
  enableMultipleCountries,
  ...props
}: ControlledPhoneInputProps) => {
  const { control } = useFormContext();
  const { countryCodes } = useCountriesData();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ref, ...field }, fieldState: { invalid, error, isTouched } }) => (
        <PhoneInput
          {...props}
          countries={countryCodes}
          selectAriaLabel="Phone code input"
          inputAriaLabel="Phone number input"
          value={value || ''}
          disabled={disabled}
          enableMultipleCountries={enableMultipleCountries}
          isInvalid={invalid && isTouched}
          error={error?.message}
          {...field}
        />
      )}
    />
  );
};
